// debugConfig.js -- supports ?debug=1 for verbose build/env info